// /api/v1/product-serials answers with a bare array, unlike the wrapped
// {data:{data}} most of this API uses. Tolerate both.
export const parseSerials = (res) =>
  Array.isArray(res?.data) ? res.data : (res?.data?.data ?? []);
